import { TandemTool } from "../../base/TandemTool.js";
import { logger } from "../../../../../../core/logger.js";

export class DeleteFileTool extends TandemTool {
  constructor() {
    super();
    this.toolName = "deleteFileTool";
  }

  /**
   * @param {string} path
   * @param {boolean} [recursive=false]
   * @returns {Promise<Object>}
   */
  async deleteFile(path, recursive = false) {
    try {
      if (!path || typeof path !== "string") {
        return this.returnError({}, "Valid file or directory path required");
      }

      const api = this.getTandemLocalAppApi();
      if (!api?.deleteFile) {
        return this.returnError(
          {},
          "Tandem deletes require Revolt Desktop (tandemAPI.deleteFile)."
        );
      }

      const root = this.getTandemWorkingDirectoryRoot();
      if (!root) {
        return this.returnError(
          {},
          "Tandem has no project folder set (working directory path)."
        );
      }

      const normalizedPath = this.normalizeAndValidatePath(path);
      if (!normalizedPath) {
        return this.returnError({}, "Invalid path");
      }
      const relativePath = normalizedPath.replace(/^\/+/, "");
      if (!relativePath) {
        return this.returnError({}, "Cannot delete project root");
      }

      const res = await api.deleteFile({
        rootPath: root,
        relativePath,
        recursive,
      });

      if (!res?.success) {
        return this.returnError({}, res?.error || "Failed to delete on disk");
      }

      const type = res.type === "directory" ? "directory" : "file";
      logger.log(
        {
          tags: "tools|tandem|deletefile|info",
          color1: "lime",
        },
        `Tandem deleted ${type}: ${normalizedPath}`,
        { path: normalizedPath, recursive: !!recursive }
      );

      return this.returnSuccess(
        {
          path: normalizedPath,
          type,
          recursive: type === "directory" ? !!recursive : undefined,
        },
        type === "directory"
          ? "Directory deleted successfully"
          : "File deleted successfully"
      );
    } catch (error) {
      logger.error(
        { tags: "tools|tandem|deletefile|error", color1: "red" },
        `Tandem failed to delete: ${path}`,
        error
      );
      return this.returnError({}, error.message);
    }
  }
}
